<template>
    <div>
            <!--        CARD FOR LIST FILTERS-->
            <div class="flex flex-row gap-3">
                <div class="flex w-96">
                    <v-text-field
                        v-model="search"
                        outlined
                        label="Search"
                        dense
                        prepend-inner-icon="mdi-magnify"
                    ></v-text-field>
                </div>


            </div>

            <!--        CARD FOR THE LIST-->
            <div class="bordered_up_top">
                <v-card id="table_card" class="d-flex flex-row container-fluid" flat>
                    <v-card-text class="pa-0">
                        <div class="px-7">
                            <v-layout child-flex>
                                <smart-table
                                    id="smartnav_table"
                                    endpoint="smartnav.list"
                                    :headers="headers"
                                    :search="search"
                                    flat
                                    @click:row="doSomething"
                                >
                                </smart-table>
                            </v-layout>
                        </div>
                    </v-card-text>

                </v-card>
            </div>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import SmartTable from "@/Generic/SmartTable";

export default {
    name: "SmartNavIndex",
    layout: (h, page) => {
        return h(AppLayout, [
            page
        ])
    },
    components: {
        SmartTable,
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data() {
        return {
            search: null,
            filters: {
                id: undefined,
                name: undefined,
                name_route: undefined,
            },
        }
    },
    computed: {
        headers() {
            return [
                // {value: 'id',           text: 'ID',         align: `start`,  sortable: true,     filterable: true,   search: this?.filters?.id  },
                {value: 'name',         text: 'Name',       align: `start`,  sortable: true,     filterable: true,   search: this?.filters?.name  },
                {value: 'name_route',   text: 'Route',      align: `start`,  sortable: true,     filterable: true,   search: this?.filters?.name_route  },
            ]
        },
    },
    methods: {
        doSomething(item) {
            this.$inertia.visit(route('smartnav.show', item))
        },
    },
}
</script>

<style>
table tr td {
    border-bottom: 0 !important;
}

    .filters_search {
        min-width: 100px; max-width: 100%;
    }

    .filters_select {
        min-width: 100px; max-width: 200px;
    }

    .filters_button {
        min-width: 50px; max-width: 100px;
    }

    .bordered_up_top {
        border-top: 5px solid #4c4c4c !important;
    }
.bordered_up_top {
    border-top: 5px solid #4c4c4c !important;
}

.v-data-table__mobile-row {
    align-items: flex-start;
}

#smartnav_table > .v-data-table__wrapper > table > tbody > tr.v-data-table__mobile-table-row {
    border-top: solid;
    padding-top: 15px;
}

#smartnav_table .v-data-table__mobile-table-row {
    padding-bottom: 15px;
}

</style>
